export default {
	section_banner: {
		title: {
			one: '心のために',
		},
		main_title: {
			one: 'お客様',
		},
		sub_title: {
			one: '＆ザ',
			two: '消費者',
		},
		paragraph: {
			one: '機械学習を使用してビジネスを保護し、顧客の資産と消費者の両方を保護することができます。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Contact Sales Dept',
		},
	},

	question_sec: {
		label: 'あなたのニーズに合わせて構築',
		title: {
			one: 'あなたのビジネスには高度にカスタマイズ可能な',
			two: 'コマースソリューション?',
		},
		cta_buttons: {
			one: '当社の事業について',
		},
	},

	credit_system: {
		label: '安全な取引',
		title: {
			one: 'リッチ',
			two: '経験',
		},
		paragraph: {
			one: 'ブロックチェーンのノウハウを基に作られたJPWorldPayを通じて、安全に取引を行ってください。',
			two: 'ブロックチェーンの始まりが知られるようになりました。',
		},
	},

	credit_system_lt: {
		label: '自信と信頼性',
		title: {
			one: '取引',
			two: '安全に',
		},
		paragraph:
			'世界で最も安全なブロックチェーンにより、世界中のお客様に安心と信頼をもってリーチできます。JPWorldPayは高度なセキュリティとグローバルなアクセス性を活用し、スムーズで国境を越えた取引を実現します。お客様の所在地に関わらず、安全かつ効率的にお客様とつながることができます。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	credit_system_rt: {
		label: '脅威に対する防御',
		title: {
			one: '不正行為の検出',
			two: 'テクノロジー',
		},
		paragraph:
			'当社の不正検出ツールは取引ごとに進化し、既存および進化する脅威からお客様を保護します。JPWorldPayは取引パターンをリアルタイムで分析することで、脅威に対するプロアクティブな防御を実現します。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
